import classNames from "classnames";
import { motion } from "framer-motion";
import { ReactNode, useState } from "react";
import { Icon } from "../icons/icon";

export const BreakdownAccordion = ({
  title,
  children,
  tooltip,
  className,
}: {
  title: string;
  children: ReactNode;
  tooltip?: string;
  className?: string;
}) => {
  const [viewBreakdown, setViewBreakdown] = useState<boolean>(false);
  return (
    <div
      className={classNames(
        "finances-card-container flex flex-col gap-6",
        className
      )}
    >
      <div className="flex items-center justify-between gap-4">
        <p className="flex-1 font-bold text-pry-dark-green-300 flex items-center gap-1">
          {title}

          {tooltip ? (
            <Icon
              svg="help-circle"
              width={16}
              height={16}
              id={"month-inflow-tooltip"}
              className="text-[#A4A7AE]"
              data-tooltip-id="tooltip"
              data-tooltip-content={tooltip}
            />
          ) : undefined}
        </p>

        <button
          type="button"
          className="size-[32px] bg-pry-green-200 text-white rounded-full flex items-center justify-center"
          onClick={() => {
            setViewBreakdown(!viewBreakdown);
          }}
        >
          <Icon
            svg="caret-down"
            width={24}
            height={24}
            className={classNames(
              "transition-all duration-500",
              viewBreakdown ? "rotate-180" : ""
            )}
          />
        </button>
      </div>

      {viewBreakdown ? (
        <motion.div
          initial={{ height: 0 }}
          animate={{ height: "auto" }}
          exit={{ height: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          className="overflow-hidden"
        >
          {children}
        </motion.div>
      ) : undefined}
    </div>
  );
};
